<div class="payment-card-options">
  <img src="/assets/images/qt-payment-visa.png" alt="QT payment visa" />
  <img src="/assets/images/qt-payment-master.png" alt="QT payment master" />
  <img src="/assets/images/qt-payment-digicert.png" alt="QT payment digicert" />
</div>
